<div id="payments">
    <!--begin::Form-->

    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="mt-5 font-weight-bolder">
                <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "PAYMENTS.MAKE_PAYMENTS" | translate }}
            </h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="bg-white rounded border border-black" style="padding: -1.175rem 1.42rem;">
                        <div class="font-size-h6 px-2">{{ "PAYMENTS.DUE" | translate }}</div>
                        <div class="font-size-h5 px-2 text-success font-weight-bolder">{{ totalPayment | number:'1.2-2' }}</div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <button type="submit" class="btn btn-lg btn-block btn-success font-uppercase font-weight-bolder" [disabled]="!totalPayment||calc==paymentCalc.HasError" (click)="submitPayment($event, paymentModal)">{{ "PAYMENTS.PAYMENT" | translate }}</button>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="calc === paymentCalc.HasError">
        <div class="my-5 alert alert-danger" >
            <div class="alert-text font-boldest">{{ "PAYMENTS.CUSTOM1_AMOUNT_ERROR" | translate }}</div>
        </div>
    </ng-container>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "PAYMENTS.MAKE_PAYMENTS" | translate }}</h3>
            </div>
        </div>
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="text-light" width="20%">
                            {{ "INSURANCE.NUM_POLICY" | translate }}
                        </th>
                        <!--th class="text-light">
                            {{ "INSURANCE.UNITY" | translate }}
                        </--th -->
                        <th class="text-light">
                            {{ "INSURANCE.START_DATE" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.DUE_DATE" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.PRIMA" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "PAYMENTS.BALANCE" | translate }}
                        </th>
                        <th class="text-light" width="15%">
                            {{ "PAYMENTS.DUE" | translate }}
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payment of paymentService.items$ | async; let i = index">
                            <td>{{payment.NroDePoliza}}</td>
                            <td>{{payment.FechaDesde  | date: 'MM/dd/yyyy' }}</td>
                            <td>{{payment.FechasHasta | date: 'MM/dd/yyyy' }}</td>
                            <td>
                                <label>
                                    <input type="hidden" id="numPolicie{{i}}" name="numPolicie{{i}}"  value="{{payment.NroDePoliza}}" />
                                    <input type="hidden" id="idPolicie{{i}}" name="idPolicie{{i}}"  value="{{payment.IdPoliza}}" />
                                    <input type="hidden"  id="dueAmount{{i}}" name="due{{i}}" value="{{payment.Saldo}}" (click)="clickAmount($event, payment.Saldo, i);" checked />
                                    <span></span>
                                   &nbsp;{{payment.Saldo | number:'1.2-2'}}
                                </label>
                            </td>
                            <td>
                                <label class="radio  radio-success" *ngIf="!multipayment">
                                    <input type="radio"  id="realDueAmount{{i}}" name="due" value="{{payment.Exigible}}" (click)="clickAmount($event, payment.Exigible, i);"/>
                                    <span></span>
                                   &nbsp;{{ payment.Exigible | number:'1.2-2' }}
                                </label>
                                <label class="checkbox  checkbox-success" *ngIf="multipayment">
                                    <input type="checkbox" id="realDueAmount{{i}}" name="due{{i}}" value="{{payment.Exigible}}" (click)="clickAmount($event, payment.Exigible, i);"/>
                                    <span></span>
                                   &nbsp;{{ payment.Exigible | number:'1.2-2' }}
                                </label>
                            </td>

                            <td>
                                <input
                                    class="form-control form-control-solid amount font-bold"
                                    type="text"
                                    placeholder="Monto"
                                    id="amount{{i}}"
                                    name="amount{{i}}"
                                    autocomplete="off"
                                    [readonly]= "payment.IdAplicaPagoParcial==2"
                                    value="0.00"
                                    (keyup)="changeAmount()"
                                />
                            </td>
                            
                        </tr>

                        <tr *ngIf="!(paymentService.items$ | async)?.length">
                            <td colspan="6">
                                <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>

<div class="paymentModal">
    <ng-template #paymentModal let-c="close" let-d="dismiss">
        <form class="form fv-plugins-bootstrap fv-plugins-framework"
                novalidate="novalidate"
                [formGroup]="paymentForm"
                (ngSubmit)="applyPayment()"
                >
            <div class="modal-header">
                <h4 class="modal-title font-weight-bolder">{{ "PAYMENTS.PROCESS_PAYMENT" | translate }}:  <span class="font-boldest text-success">$ {{ totalPayment | number:'1.2-2' }}</span></h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div  *ngIf="paymentState === paymentStates.Init">

                    <!-- begin::Alert error-->
                    <ng-container *ngIf="paymentError === paymentStates.HasError">
                        <div class="mb-5 alert alert-light-danger alert-dismissible" >
                        <div class="alert-text">{{ "PAYMENTS.PAYMENT_ERROR" | translate }}</div>
                        </div>
                    </ng-container>
                    <!-- end::Alert error-->

                    <div class="row">
                        <div class="form-group col-6">
                            <label class="sr--only font-size-h6 font-weight-bolder text-dark">{{ "INPUT.FIRSTNAME" | translate }}</label>
                            <input
                                class="form-control form-control-solid  placeholder-dark-75"
                                type="text"
                                name="firstname"
                                formControlName="firstname"
                                placeholder="Nombre"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['firstname'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['firstname']
                                }"
                            ></ng-container>
                        </div>
                        <div class="form-group col-6">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.LASTNAME" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="lastname"
                                formControlName="lastname"
                                placeholder="Apellido"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['lastname'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['lastname']
                                }"
                            ></ng-container>
                        </div>
                        <!--end::Form group-->
                    </div>
                    
                    <div class="row">
                        <div class="col-12 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.ADDRESS" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="address"
                                formControlName="address"
                                placeholder="Dirección"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['address'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['address']
                                }"
                            ></ng-container>
                        </div>
                        <!--end::Form group-->

                        <div class="col-4 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.CITY" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="city"
                                formControlName="city"
                                placeholder="Ciudad"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['city'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['city']
                                }"
                            ></ng-container>
                        </div>
                        <!--end::Form group-->

                        <div class="col-4 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.STATE" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="state"
                                formControlName="state"
                                placeholder="Estado/Provinca"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['state'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['state']
                                }"
                            ></ng-container>
                        </div>
                        <!--end::Form group-->


                        <div class="col-4 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.ZIP" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="zip"
                                formControlName="zip"
                                placeholder="Código Postal"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['zip'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['zip']
                                }"
                            ></ng-container>
                        </div>
                    </div>

                    <!--end::Form group-->
                    <hr>

                    <div class="row">
                        <div class="col-12 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.CREDITCARD" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="card_number"
                                formControlName="card_number"
                                placeholder="Número de Tarjeta"
                                autocomplete="off"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['card_number'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['card_number']
                                }"
                            ></ng-container>
                        </div>

                        <!--end::Form group-->

                        <div class="col-3 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.EXPIRATION_MONTH" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="text"
                                name="expiration_month"
                                formControlName="expiration_month"
                                placeholder="Mes"
                                autocomplete="off"
                                maxlength="2"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['expiration_month'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['expiration_month']
                                }"
                            ></ng-container>
                        </div>

                        <!--end::Form group-->

                        <div class="col-3 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.EXPIRATION_YEAR" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="number"
                                name="expiration_year"
                                formControlName="expiration_year"
                                placeholder="Año"
                                autocomplete="off"
                                maxlength="2"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['expiration_year'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['expiration_year']
                                }"
                            ></ng-container>
                        </div>

                        <!--end::Form group-->
                        <div class="col-2 form-group"></div>

                        <div class="col-4 form-group">
                            <label class="sr--onlyfont-size-h6 font-weight-bolder text-dark">{{ "INPUT.CVV" | translate }}</label>
                            <input
                                class="form-control form-control-solid "
                                type="number"
                                name="cvv"
                                formControlName="cvv"
                                placeholder="Código de Seguridad"
                                autocomplete="off"
                                maxlength="4"
                                [ngClass]="{
                                'is-invalid': paymentForm.controls['cvv'].invalid
                                }"
                            />
                            <ng-container
                                [ngTemplateOutlet]="formError"
                                [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'Campo requerido',
                                control: paymentForm.controls['cvv']
                                }"
                            ></ng-container>
                        </div>
                        <!--end::Form group-->
                    </div>
                </div>

                <div class="row" *ngIf="paymentState === paymentStates.Submitted">
                    <div class="loading-totalesModal">
                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                    </div>
                </div>

                <div class="row" *ngIf="paymentState === paymentStates.Finishied">
                    <div class="mb-5 alert alert-success col-12" >
                        <div class="alert-text font-weight-bolder">{{ paymentMessage }}</div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                        <button type="submit" [disabled]="paymentForm.invalid" [hidden]="paymentState === paymentStates.Finishied || paymentState === paymentStates.Submitted " class="btn btn-success mr-2 font-weight-boldest ">{{ "PAYMENTS.PAYMENT" | translate }}</button>
                        <button type="button" class="btn btn-default" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate }}</button>
            </div>

        </form>
    </ng-template>
</div>


<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)"
  >
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>
